import { render, staticRenderFns } from "./ProtocoloVerdeGraos.vue?vue&type=template&id=532af3a2&lang=pug"
import script from "./ProtocoloVerdeGraos.vue?vue&type=script&lang=js"
export * from "./ProtocoloVerdeGraos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports